module.exports = __webpack_public_path__ + "img/checkbox-all-black.8a509aac.svg";